<template>
  <div class="form-group">
    <label>{{ trans('app.copy_to') + `...` }}</label><br>
    <div class="select-wrapper" :style="{height:selectHeight}">
      <select v-model="modelData" class="form-control"
              ref="select"
              :size="selectSize"
              @focus="selectFocus"
              @blur="selectBlur"
              @change="selectChange"
      >
        <slot name="options"></slot>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectSize: 1,
      selectHeight: null,
      modelData: null,
    };
  },
  methods: {
    selectFocus() {
      let ratio = this.$refs.select.options.length;
      ratio = ratio > 5 ? 5 : ratio;
      this.selectSize = ratio;
      this.selectHeight = (20 * ratio).toString() + 'px';

    },
    selectBlur() {
      this.selectSize = 1;
      this.selectHeight = null;
    },
    selectChange($event) {
      $event.target.blur();
      this.$emit('change', {
        value: this.modelData,
      });
    }
  }
}
</script>